<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <v-btn @click="show">Show langs</v-btn>
            <v-btn @click="add">Add more</v-btn>

            <template v-for="lang in langs">
                <div>{{lang.name}}</div>
            </template>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        data() {
            return {
                langs: null
            }
        },
        methods: {
            show() {
                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    console.log('res', res)
                    this.langs = res
                })
            },
            add() {
                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    console.log('res', res)
                    this.langs = this.langs.concat(res)
                })
            }
        }
    }
</script>